const Team = () => {
  const teamList = document.querySelector('.team__list');
  const teamBtn = document.querySelector('.team__btn');
  
  if (teamList) {
    if (teamBtn) {
      teamBtn.addEventListener('click', () => {
        if (teamList.classList.contains("expanded")) {
          teamList.classList.remove("expanded");
          [teamBtn.dataset.text, teamBtn.textContent] = [teamBtn.textContent, teamBtn.dataset.text];
        } else {
          teamList.classList.add("expanded");
          [teamBtn.dataset.text, teamBtn.textContent] = [teamBtn.textContent, teamBtn.dataset.text];
        }
      });
    }
  }
};

export default Team;
